// src/useSmoothScroll.js
import { useEffect } from "react";

export default function useSmoothScroll() {
  useEffect(() => {
    const headerSelector = ".main-header"; // adjust to your header class
    const duration = 700; // ms

    function easeInOutQuad(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    }

    function animateScroll(container, to, dur) {
      const start = container.scrollTop || window.pageYOffset;
      const change = to - start;
      const startTime = performance.now();

      function step(now) {
        const elapsed = now - startTime;
        const val = easeInOutQuad(Math.min(elapsed, dur), start, change, dur);
        if (container === document.documentElement || container === document.body) {
          window.scrollTo(0, val);
        } else {
          container.scrollTop = val;
        }
        if (elapsed < dur) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    function onClick(e) {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;

      const href = anchor.getAttribute("href");
      if (!href || href === "#") return;

      const id = href.slice(1);
      const target = document.getElementById(id);
      if (!target) return;

      e.preventDefault();

      const header = document.querySelector(headerSelector);
      const headerHeight = header ? header.offsetHeight : 80;
      const targetY = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      animateScroll(document.documentElement, targetY, duration);

      // Update URL hash
      window.history.pushState(null, "", `#${id}`);
    }

    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);
}
